<template>
  <div
    v-if="isLink"
    :class="customClass"
    @click="onDiscoverProClicked"
    :data-e2e="FinancialAdvisorEstateCypressAttribute.planning.views.ADVISOR_PRO_UPGRADE_LINK"
  >
    {{ text }}
  </div>
  <div v-else-if="forceIconOnSmallScreens && shouldShowIconOnly">
    <div
      class="small-rocket-card-wrapper is-clickable"
      @click="onDiscoverProClicked"
      :data-e2e="FinancialAdvisorEstateCypressAttribute.nav.buttons.ADVISOR_PRO_UPGRADE_ICON_BUTTON"
    >
      <div class="small-rocket-card">
        <img src="@/assets/illustrations/launch-rocket.svg" :width="24" />
      </div>
    </div>
  </div>
  <ButtonView
    v-else
    :class="customClass"
    :type="type"
    :outlined="outlined"
    @click="onDiscoverProClicked"
    :data-e2e="FinancialAdvisorEstateCypressAttribute.planning.buttons.ADVISOR_PRO_UPGRADE_BUTTON"
  >
    <div class="is-flex-centered">
      <i v-if="iconClass" :class="iconClass" />
      <span :class="{ 'ml-2': iconClass }">{{ text }}</span>
    </div>
  </ButtonView>
</template>

<script>
import { HasResizeHandlerMixin } from '@/modules/core/app/mixins/HasResizeHandlerMixin';
import { DeviceBreakpoint } from '@/modules/core/ui/enums/DeviceBreakpoint';
import { FinancialAdvisorEstateCypressAttribute } from '@/modules/financialadvisor/constants/FinancialAdvisorEstateCypressAttribute';
import FinancialAdvisorProUpsellButtonUIService from '@/modules/financialadvisor/services/FinancialAdvisorProUpsellButtonUIService';
import { ButtonType } from '@/modules/core/app/enums/button/ButtonType';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FinancialAdvisorProUpsellButton',
  mixins: [HasResizeHandlerMixin],
  props: {
    isLink: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    customClass: {
      type: String,
      default: ''
    },
    iconClass: {
      type: String,
      default: null
    },
    forceIconOnSmallScreens: {
      type: Boolean,
      default: false
    },
    entryPoint: {
      type: String,
      default: null
    },
    outlined: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: ButtonType.IS_PRIMARY
    }
  },
  static: {
    FinancialAdvisorEstateCypressAttribute,
    ButtonType
  },
  computed: {
    shouldShowIconOnly() {
      return this.windowWidth <= DeviceBreakpoint.DESKTOP;
    }
  },
  methods: {
    onDiscoverProClicked() {
      FinancialAdvisorProUpsellButtonUIService.showUpsellModal({
        parent: this,
        entryPoint: this.entryPoint
      });
    }
  }
};
</script>

<style scoped>
.small-rocket-card-wrapper {
  box-shadow: 0, var(--ce-12px), var(--ce-32px), rgba(0, 0, 0, 0.08);
  position: relative;
  width: var(--ce-55px);
  margin: 0 auto;
  padding: var(--ce-2px);
  border-radius: var(--ce-8px);
  background: linear-gradient(to top right, #425df6, #ff865b);
}

.small-rocket-card {
  background: white;
  padding: var(--ce-10px);
  border-radius: var(--ce-6px);
  text-align: center;
}
</style>
